import React from 'react';
import { translate } from 'react-i18next';

import {colors, shadow, fontSizes, spacings, layout} from 'style';

const styles = {
        popUpMenu: {
            cursor: 'auto',
            position: 'absolute',
            zIndex : 1,
            top: 'calc(100% + 34px)',
            right: '-10px',
            width: '240px',
            backgroundColor: '#fff',
            border: '1px solid ' + colors.themeDarkGrey,
            borderRadius: '8px',
            boxShadow: 'rgba(0,0,0,0.1) 0px 2px 4px 0px',
        },
        popUpMenuContent: {
            position: 'relative',
            top: '0px',
            left: '0px',
            backgroundColor: '#fff',
            width: '100%',
            boxShadow: 'none',
            border: 'none',
            paddingLeft: spacings.base,
            paddingRight: spacings.base,
        },
        popUpMenuPointer: {
            backgroundColor: 'inherit',
            position: 'absolute',
            top: '0px',
            right: '22px',
            marginTop: '-7px',
            marginLeft: '-7px',
            width: '14px',
            height: '14px',
            transform: 'rotate(45deg)',
            boxShadow: 'inherit',
            border: 'inherit',
        },
        popUpMenuItem: {
            display: 'block',
            cursor: 'pointer',
            color: colors.themeDarkerGrey,
            borderBottom: '1px solid ' + colors.themeDarkGrey,
            paddingTop: spacings.small,
            paddingBottom: spacings.small,
            paddingLeft: '0px',
            paddingRight: '0px',
        },
}

const PopUpMenu = ({m, t, style, popUpMenuLinks, onSignOut, setRef}) => (
    <div style={{...styles.popUpMenu, ...style}} className='tablet or lower hidden' ref={setRef} onClick={e=>e.stopPropagation()}>
        <div style={styles.popUpMenuPointer}></div>
        <div style={{...styles.popUpMenu, ...styles.popUpMenuContent}}>

            {popUpMenuLinks.map((link, index)=>(
                <a key={link.href || index} className='item' style={{...styles.popUpMenuItem, ...link.style, ...(index === popUpMenuLinks.length - 1 ? {borderBottom:'none'} : {})}} href={link.href} onClick={link.onClick}>{t(link.title)}</a>
            ))}
        </div>
    </div> 
);
export default translate('sidebar')(PopUpMenu);



// WEBPACK FOOTER //
// ./src/modules/navigation/PopUpMenu.js